import { STORAGE, useLocalStorageStore } from '@/store';

export function getCtaButtonHrefWithSessionId(
  afterRegistrationRedirect?: string
) {
  if (typeof window === 'undefined') return '/users/sign_up';

  const sessionId = localStorage.getItem('uuid');
  const redirect = afterRegistrationRedirect
    ? '&redirect=' + afterRegistrationRedirect
    : '';

  return `/users/sign_up?session_id=${sessionId}${redirect}`;
}

export const getRandomDelay = (min = 1.8, max = 2.4): number =>
  Number((Math.random() * (max - min + 1) + min).toFixed(1));

export const getVisibleBonusCode = (
  hiddenBonusCodes: string[],
  name: string
) => (hiddenBonusCodes.includes(name) ? '' : name);

export const REG_MODAL_FLOW_PARAMS = ['regModal', 'reg_modal'];

export const AFFILIATE_QUERY_PARAMS = {
  redirectOnClose: 'go',
  withoutExitPopup: 'noexitp',
  newTerms: 'new_terms',
  oneTerms: 'one_terms',
  autoCheck: 'auto_check',
  regModalTheme: 'theme',
  googleAuth: 'google_auth',
} as const;

export const NDB_LANDINGS_LIST: ReadonlySet<string> = new Set([
  'powerslot',
  'lyzer40-games',
  '50zilla',
  'spin50',
  'lucky35fs-games',
  'fortune',
  'juicylvl',
  'doubleslot-top',
  'doubleslot-gold',
  'doubleslot-ndb',
  'hotslot-d',
  'doubleslot-slot',
  'hotice-fixedscroll',
  'betslot-golden',
  'betslot-green',
  'spooky',
  'hotslot-s',
  'happyslot',
  'happyslot-time',
  'jinglewin',
  'snowcode',
  'asksnow',
  'sweetup',
  'luxslot',
  'luxzilla',
  'claimlux',
  'bonuslux',
  'circus',
  'boost',
  'boost-db',
  'patrickup',
  'easterup',
  'royalup',
  'chickenup',
  'auspokies',
  '50dragon',
  'dragon',
  'coinup',
  'slotwin',
  'mybeer',
]);

export const isCdnImg = (src: string) => src.startsWith('https://');

export interface AffiliateRegConfig {
  regModalTheme?: string | null;
  shouldHideExitPopup: boolean;
  shouldRedirectOnExit: boolean;
  newTerms: boolean;
  oneTerms: boolean;
  autoCheck: boolean;
  googleAuth: boolean;
}

export const DEFAULT_REG_FORM_CONFIG: AffiliateRegConfig = {
  shouldHideExitPopup: false,
  shouldRedirectOnExit: false,
  newTerms: false,
  oneTerms: false,
  autoCheck: false,
  googleAuth: false,
};

export const setGoogleOAuthAffiliateParams = (config: AffiliateRegConfig) => {
  useLocalStorageStore
    .getState()
    .replace(STORAGE.GOOGLE_OAUTH_AFFILIATE_PARAMS, config);
};

export const getGoogleOAuthAffiliateParams = (): AffiliateRegConfig | null =>
  useLocalStorageStore
    .getState()
    .get<AffiliateRegConfig | null>(STORAGE.GOOGLE_OAUTH_AFFILIATE_PARAMS);

export const clearGoogleOAuthAffiliateParams = () => {
  useLocalStorageStore.getState().remove(STORAGE.GOOGLE_OAUTH_AFFILIATE_PARAMS);
};

export const replaceFsCount = (text: string, fsCount?: number | null) =>
  fsCount ? text.replace(/\d+/, String(fsCount)) : text;

export const replaceTermsTillDate = (
  rules: string[],
  date: string | undefined
): string[] => {
  const hasDatePlaceholder = rules.some((rule) => rule.includes('{{date}}'));
  if (hasDatePlaceholder || !date) return rules;
  return rules.map((rule, i) =>
    i === rules.length - 1 ? rule.replace(/\d{2}\.\d{2}\.\d{2,4}/, date) : rule
  );
};

const BTC_AMOUNT_REGEXP = /,?\s*[\d.]+\s*BTC/gi;

export const removeBtcFromTerms = (
  rules: unknown[],
  shouldRemove: boolean
): unknown[] => {
  if (!shouldRemove) return rules;
  return rules.map((rule) =>
    typeof rule === 'string' ? rule.replace(BTC_AMOUNT_REGEXP, '') : rule
  );
};

export const getImgSrc = (folderPath: string, src: string) =>
  `${folderPath}${src}`;

const BASE_MULTIPLIER = 0.1 * 5;
const NOK_MULTIPLIER = 10;

// Omits trailing .00 (e.g. 20.00 → "20"), keeps meaningful decimals (e.g. 17.5 → "17.50")
const formatAmount = (value: number) => {
  const fixed = value.toFixed(2);
  return fixed.endsWith('.00') ? String(Math.round(value)) : fixed;
};

export const calcFsMaxWin = (fsCount: number) => {
  const base = fsCount * BASE_MULTIPLIER;

  return {
    maxWin: formatAmount(base),
    maxWinNok: formatAmount(base * NOK_MULTIPLIER),
  };
};
